module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@cian/utils");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EInputType;
(function (EInputType) {
    EInputType["search"] = "search";
    EInputType["map"] = "map";
    EInputType["mobile"] = "mobile";
    EInputType["mainpage"] = "mainpage";
    EInputType["tablet"] = "tablet";
})(EInputType = exports.EInputType || (exports.EInputType = {}));
var ESuggestType;
(function (ESuggestType) {
    ESuggestType["city"] = "city";
    ESuggestType["district"] = "district";
    ESuggestType["railway"] = "railway";
    ESuggestType["underground"] = "underground";
    ESuggestType["businessCenter"] = "businessCenter";
    ESuggestType["shoppingCenter"] = "shoppingCenter";
    ESuggestType["road"] = "road";
    ESuggestType["village"] = "village";
    ESuggestType["newbuilding"] = "newbuilding";
    ESuggestType["geo"] = "geo";
})(ESuggestType = exports.ESuggestType || (exports.ESuggestType = {}));
var EMessageType;
(function (EMessageType) {
    EMessageType["EMPTY"] = "EMPTY";
    EMessageType["ERROR"] = "ERROR";
})(EMessageType = exports.EMessageType || (exports.EMessageType = {}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(3);
function isBuildingSuggest(suggestion) {
    return [
        types_1.ESuggestType.newbuilding,
        types_1.ESuggestType.businessCenter,
        types_1.ESuggestType.shoppingCenter,
        types_1.ESuggestType.village
    ].includes(suggestion.type);
}
exports.isBuildingSuggest = isBuildingSuggest;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("lodash.isempty");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getSuggestionsCount(suggestions) {
    return Object.keys(suggestions)
        .reduce(function (acc, key) {
        var val = suggestions[key];
        return (val) ? acc + val.length : acc;
    }, 0);
}
exports.getSuggestionsCount = getSuggestionsCount;
function sortSuggestions(data) {
    var sortOrder = data.sortOrder, suggestions = data.suggestions;
    return sortOrder.map(function (item) { return suggestions[item]; });
}
exports.sortSuggestions = sortSuggestions;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionPopup_1 = __webpack_require__(21);
exports.SuggestionPopup = SuggestionPopup_1.SuggestionPopup;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
tslib_1.__exportStar(__webpack_require__(9), exports);
tslib_1.__exportStar(__webpack_require__(7), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GeoSuggest_1 = __webpack_require__(10);
exports.GeoSuggest = GeoSuggest_1.GeoSuggest;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var isEmpty = __webpack_require__(5);
var outside_click_component_1 = __webpack_require__(11);
var utils_1 = __webpack_require__(2);
var types_1 = __webpack_require__(3);
var types_2 = __webpack_require__(4);
var SuggestionInput_1 = __webpack_require__(12);
var CloseButton_1 = __webpack_require__(15);
var Preloader_1 = __webpack_require__(18);
var suggestions_1 = __webpack_require__(6);
var SuggestionPopup_1 = __webpack_require__(7);
var Chevron_1 = __webpack_require__(37);
var style = __webpack_require__(41);
var SYMB_COUNT_FOR_POPUP = 2;
var GeoSuggest = /** @class */ (function (_super) {
    tslib_1.__extends(GeoSuggest, _super);
    function GeoSuggest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.globalSuggestionsCount = 0;
        _this.inputRef = null;
        _this.state = {
            selectedItem: 0,
            isPopupOpen: false,
            hasFocus: false,
        };
        _this.onItemSelect = function (index) {
            _this.setState({ selectedItem: index });
            if (_this.props.onItemSelect) {
                _this.props.onItemSelect(index);
            }
        };
        _this.onKeyDown = function (event) {
            var selectedItem = _this.state.selectedItem;
            if (!_this.props.suggestData || isEmpty(_this.props.suggestData.suggestions)) {
                return;
            }
            switch (event.keyCode) {
                //down
                case 40:
                    event.preventDefault();
                    _this.selectItem(selectedItem + 1);
                    break;
                //up
                case 38:
                    event.preventDefault();
                    _this.selectItem(selectedItem - 1);
                    break;
                //tab, enter
                case 9:
                case 13:
                    event.preventDefault();
                    _this.onEnterPress();
                    break;
                //esc
                case 27:
                    _this.onBlur(_this.setSelectedValue);
                    break;
                default:
                    break;
            }
        };
        _this.setSelectedValue = function () {
            var _a = _this.props, onValueChange = _a.onValueChange, _b = _a.selectedValue, selectedValue = _b === void 0 ? '' : _b;
            onValueChange(selectedValue);
        };
        _this.onEnterPress = function () {
            if (!_this.props.suggestData || isEmpty(_this.props.suggestData.suggestions)) {
                return;
            }
            var index = _this.state.selectedItem || 0;
            var suggestions = suggestions_1.sortSuggestions(_this.props.suggestData)
                .reduce(function (acc, group) { return group !== undefined ? acc.concat(group) : acc; }, []);
            var selected = suggestions[index];
            var cb = function () { return _this.props.onItemClick({
                title: selected.type === types_1.ESuggestType.geo ? selected.value : selected.fullName,
                group: selected.type,
                id: selected.type === types_1.ESuggestType.geo ? undefined : selected.id,
                regionId: selected.type === types_1.ESuggestType.geo ? undefined : selected.regionId,
                link: types_2.isBuildingSuggest(selected) ? selected.link : undefined,
            }); };
            _this.onBlur(cb);
        };
        _this.onChevronClick = function () {
            if (_this.state.isPopupOpen) {
                _this.onBlur(_this.setSelectedValue);
            }
            else {
                if (_this.inputRef) {
                    _this.inputRef.focus();
                }
            }
        };
        _this.onCloseButton = function () {
            _this.onBlur(function () { return _this.props.onValueChange(''); });
        };
        _this.onItemClick = function (params) {
            _this.onBlur(function () { return _this.props.onItemClick(params); });
        };
        _this.onFocus = function () {
            var error = _this.props.error;
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
            _this.setState({
                isPopupOpen: _this.props.value.length > SYMB_COUNT_FOR_POPUP &&
                    (_this.hasSuggestions(_this.props.suggestData) || !isEmpty(error)),
                hasFocus: true,
            }, _this.props.onFocus);
        };
        _this.onBlur = function (callback) {
            var onBlur = _this.props.onBlur;
            if (_this.inputRef) {
                _this.inputRef.blur();
            }
            _this.setState({
                isPopupOpen: false,
                selectedItem: 0,
                hasFocus: false,
            }, callback);
            if (onBlur) {
                onBlur();
            }
        };
        _this.getPreloaderStyle = function () {
            var inputType = _this.props.inputType;
            switch (inputType) {
                case types_1.EInputType.mobile:
                    return style['preloader-mobile'];
                case types_1.EInputType.mainpage:
                    return style['preloader-mainpage'];
                case types_1.EInputType.search:
                    return style['preloader-search'];
            }
            return undefined;
        };
        _this.hasSuggestions = function (suggestData) {
            return Boolean(suggestData && !isEmpty(suggestData.suggestions));
        };
        _this.handleOutsideClick = function () {
            if (_this.state.isPopupOpen) {
                _this.onBlur(_this.setSelectedValue);
            }
        };
        return _this;
    }
    GeoSuggest.prototype.selectItem = function (index) {
        var selectedItem = index;
        if (index < 0) {
            selectedItem = this.globalSuggestionsCount - 1;
        }
        else if (index > this.globalSuggestionsCount - 1) {
            selectedItem = 0;
        }
        this.setState({ selectedItem: selectedItem });
    };
    GeoSuggest.prototype.componentWillReceiveProps = function (newProps) {
        var _a = this.props, error = _a.error, value = _a.value, suggestData = _a.suggestData;
        if (newProps.value !== value || newProps.suggestData !== suggestData || error !== newProps.error) {
            this.setState({
                isPopupOpen: newProps.value.length > SYMB_COUNT_FOR_POPUP &&
                    this.state.hasFocus &&
                    (this.hasSuggestions(newProps.suggestData) || !isEmpty(newProps.error)),
            });
        }
    };
    GeoSuggest.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, isLoading = _a.isLoading, error = _a.error, _b = _a.suggestData, suggestData = _b === void 0 ? { sortOrder: [], suggestions: {} } : _b, disabled = _a.disabled, placeholder = _a.placeholder, onLinkClick = _a.onLinkClick, inputStyle = _a.inputStyle, inputType = _a.inputType, popupStyle = _a.popupStyle, onValueChange = _a.onValueChange;
        var _c = this.state, isPopupOpen = _c.isPopupOpen, selectedItem = _c.selectedItem;
        this.globalSuggestionsCount = (suggestData && suggestions_1.getSuggestionsCount(suggestData.suggestions)) || 0;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(style['geo-suggest'], disabled && style['disabled'])),
            React.createElement(outside_click_component_1.OutsideClick, { onOutsideClick: this.handleOutsideClick },
                inputType === types_1.EInputType.mobile && value && !isLoading && React.createElement(CloseButton_1.CloseButton, { onClick: this.onCloseButton }),
                isLoading && React.createElement(Preloader_1.Preloader, { customStyle: this.getPreloaderStyle() }),
                React.createElement("div", { className: style['input-wrapper'] },
                    React.createElement(SuggestionInput_1.SuggestionInput, { value: value, forwardRef: function (ref) { return _this.inputRef = ref; }, inputStyle: inputStyle, inputType: inputType, disabled: disabled, placeholder: placeholder, onChange: onValueChange, onKeyDown: this.onKeyDown, onFocus: this.onFocus }),
                    inputStyle === types_1.EInputType.mainpage && !isLoading &&
                        React.createElement(Chevron_1.Chevron, { isOpen: isPopupOpen, onClick: this.onChevronClick })),
                isPopupOpen && React.createElement(SuggestionPopup_1.SuggestionPopup, { suggestions: suggestData, selectedItem: selectedItem, inputType: inputType, error: error, containerStyles: popupStyle, onItemClick: this.onItemClick, onItemSelect: this.onItemSelect, onLinkClick: onLinkClick }))));
    };
    return GeoSuggest;
}(React.Component));
exports.GeoSuggest = GeoSuggest;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@cian/outside-click-component");

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionInput_1 = __webpack_require__(13);
exports.SuggestionInput = SuggestionInput_1.SuggestionInput;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var styles = __webpack_require__(14);
var utils_1 = __webpack_require__(2);
var types_1 = __webpack_require__(3);
var MAX_LENGTH_INPUT_TEXT = 255;
var INPUT_PLACEHOLDER_TEXT = 'Город, адрес, метро, район, ж/д, шоссе или ЖК';
var INPUT_LABEL_TEXT = 'Город, район, метро, адрес';
exports.SuggestionInput = function (props) {
    var value = props.value, inputType = props.inputType, inputStyle = props.inputStyle, onKeyDown = props.onKeyDown, onChange = props.onChange, onFocus = props.onFocus, disabled = props.disabled, placeholder = props.placeholder, forwardRef = props.forwardRef;
    var isMainpage = inputType === types_1.EInputType.mainpage;
    return (React.createElement(React.Fragment, null,
        isMainpage &&
            React.createElement("label", { htmlFor: "geo-suggest-input", className: styles['suggestion-input-label'] }, placeholder || INPUT_LABEL_TEXT),
        React.createElement("input", tslib_1.__assign({}, utils_1.mergeStyles(styles['suggestion-input'], inputType === types_1.EInputType.mobile && styles['mobile'], inputType === types_1.EInputType.tablet && styles['tablet'], inputType === types_1.EInputType.map && styles['map'], inputType === types_1.EInputType.search && styles['search'], isMainpage && styles['mainpage'], inputStyle), { id: "geo-suggest-input", value: value, 
            //удалил реактовский forwardRef из за несовместимости версий
            ref: forwardRef, maxLength: MAX_LENGTH_INPUT_TEXT, autoComplete: "off", onKeyDown: onKeyDown, onChange: function (event) { onChange(event.currentTarget.value); }, onFocus: onFocus, disabled: disabled, placeholder: isMainpage ? undefined : placeholder || INPUT_PLACEHOLDER_TEXT }))));
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"suggestion-input":"geosuggest_widget-suggestion-input-16d7548b0a8","suggesiton-input":"geosuggest_widget-suggesiton-input-d907ff652b8","search":"geosuggest_widget-search-d14ae57a9f5","mobile":"geosuggest_widget-mobile-8bb0f70ad2a","map":"geosuggest_widget-map-260333c9774","tablet":"geosuggest_widget-tablet-8722d2d67d6","mainpage":"geosuggest_widget-mainpage-8650af0629e","suggestion-input-label":"geosuggest_widget-suggestion-input-label-984557b1aad"};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CloseButton_1 = __webpack_require__(16);
exports.CloseButton = CloseButton_1.CloseButton;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var style = __webpack_require__(17);
exports.CloseButton = function (props) {
    return (React.createElement("button", { className: style['close-button'], onClick: function () { return props.onClick(); } },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("rect", { width: "20", height: "20", fill: "#E4E4E4", rx: "10" }),
                React.createElement("path", { fill: "#FFF", d: "M9.646 9.646l2.822-2.821a.51.51 0 0 1 .714-.007.505.505 0 0 1-.007.714l-2.821 2.822 2.821 2.821a.51.51 0 0 1 .007.714.505.505 0 0 1-.714-.007l-2.822-2.821-2.821 2.821a.51.51 0 0 1-.714.007.505.505 0 0 1 .007-.714l2.821-2.821-2.821-2.822a.51.51 0 0 1-.007-.714.505.505 0 0 1 .714.007l2.821 2.821z" })))));
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"close-button":"geosuggest_widget-close-button-f9fdaa64ef0"};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Preloader_1 = __webpack_require__(19);
exports.Preloader = Preloader_1.Preloader;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var style = __webpack_require__(20);
exports.Preloader = function (props) {
    return (React.createElement("svg", tslib_1.__assign({}, utils_1.mergeStyles(style['preloader'], props.customStyle), { viewBox: "0 0 40 40" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: style['preloader'], gradientUnits: "userSpaceOnUse", y1: "30", x2: "40", y2: "30" },
                React.createElement("stop", { offset: "0", stopColor: "#0076eb" }),
                React.createElement("stop", { offset: "1", stopColor: "#fff", stopOpacity: "0" }))),
        React.createElement("path", { fill: "url(#" + style['preloader'] + ")", d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z" })));
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"preloader":"geosuggest_widget-preloader-a926cbd2ea9","spin":"geosuggest_widget-spin-201357dd6f6"};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var utils_1 = __webpack_require__(2);
var React = __webpack_require__(0);
var isEmpty = __webpack_require__(5);
var types_1 = __webpack_require__(3);
var styles = __webpack_require__(22);
var SuggestionGroup_1 = __webpack_require__(23);
var Suggestion_1 = __webpack_require__(27);
var Message_1 = __webpack_require__(33);
var scroll_1 = __webpack_require__(36);
var suggestions_1 = __webpack_require__(6);
var types_2 = __webpack_require__(4);
var SuggestionPopup = /** @class */ (function (_super) {
    tslib_1.__extends(SuggestionPopup, _super);
    function SuggestionPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.container = null;
        _this.suggestionElements = [];
        _this.lastSelectedIndex = 0;
        _this.scrollTo = function (index, center) {
            if (center === void 0) { center = false; }
            var containerElement = _this.container;
            var valueElement = _this.suggestionElements[index];
            if (!valueElement || !containerElement) {
                return;
            }
            var parentElement = valueElement.parentElement && valueElement.parentElement.parentElement;
            if (parentElement) {
                scroll_1.scrollTo({ center: center, containerElement: containerElement, targetElement: valueElement, parentElement: parentElement });
            }
        };
        return _this;
    }
    SuggestionPopup.prototype.render = function () {
        var _this = this;
        var _a = this.props, containerStyles = _a.containerStyles, sortOrder = _a.suggestions.sortOrder, selectedItem = _a.selectedItem, onItemClick = _a.onItemClick, onLinkClick = _a.onLinkClick, _b = _a.error, error = _b === void 0 ? {} : _b, inputType = _a.inputType;
        var suggestionsSorted = suggestions_1.sortSuggestions(this.props.suggestions);
        var globalIndex = 0;
        var isMobileOrTablet = inputType === types_1.EInputType.mobile || inputType === types_1.EInputType.tablet;
        return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['geosuggest-popup'], containerStyles)), !isEmpty(error)
            ? React.createElement(Message_1.Message, { title: error.title, text: error.text })
            : React.createElement("div", { className: styles['suggestion-list'], ref: function (container) { return _this.container = container; } }, suggestionsSorted.map(function (group, index) {
                return (group &&
                    React.createElement(SuggestionGroup_1.SuggestionsGroup, { name: sortOrder[index], key: index }, group.map(function (item, index) {
                        var elIndex = globalIndex++;
                        var itemClickParams = item.type === types_1.ESuggestType.geo
                            ? { title: item.value, group: types_1.ESuggestType.geo }
                            : {
                                title: item.fullName,
                                group: item.type,
                                id: item.id,
                                regionId: item.regionId,
                                link: types_2.isBuildingSuggest(item) ? item.link : undefined,
                            };
                        return (React.createElement(Suggestion_1.Suggestion, { key: index, item: item, selected: !isMobileOrTablet && elIndex === selectedItem, inputType: inputType || types_1.EInputType.search, onClick: function () { return onItemClick(itemClickParams); }, onMouseOver: function () { return _this.onItemSelect(elIndex); }, onLinkClick: function () { return onLinkClick && types_2.isBuildingSuggest(item) &&
                                onLinkClick(item.fullName, item.type, item.id); }, forwardRef: function (itemElement) { return _this.suggestionElements[elIndex] = itemElement; } }));
                    })));
            }))));
    };
    SuggestionPopup.prototype.componentDidUpdate = function (prevProps) {
        var prevSelectedItem = prevProps.selectedItem;
        var selectedItem = this.props.selectedItem;
        if (selectedItem !== undefined &&
            prevSelectedItem !== selectedItem &&
            selectedItem !== this.lastSelectedIndex) {
            this.scrollTo(selectedItem);
            this.lastSelectedIndex = selectedItem;
        }
    };
    SuggestionPopup.prototype.onItemSelect = function (index) {
        this.lastSelectedIndex = index;
        this.props.onItemSelect(index);
    };
    return SuggestionPopup;
}(React.Component));
exports.SuggestionPopup = SuggestionPopup;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"geosuggest-popup":"geosuggest_widget-geosuggest-popup-96455739d5a","suggestion-list":"geosuggest_widget-suggestion-list-0b8f5a4efdd"};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SuggestionsGroup_1 = __webpack_require__(24);
exports.SuggestionsGroup = SuggestionsGroup_1.SuggestionsGroup;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var styles = __webpack_require__(25);
var icons_1 = __webpack_require__(26);
var TITLES = {
    addresses: 'Адреса',
    cities: 'Город',
    districts: 'Район',
    newbuildings: 'Жилые комплексы',
    shoppingCenters: 'Торговые центры',
    businessCenters: 'Бизнес-центры',
    undergrounds: 'Метро',
    railways: 'Ж/Д станции',
    villages: 'Коттеджные поселки',
    roads: 'Шоссе',
};
var TITLE_STYLES = {
    addresses: styles['addresses'],
    cities: styles['cities'],
    districts: styles['districts'],
    newbuildings: styles['newbuildings'],
    shoppingCenters: styles['shop'],
    businessCenters: styles['business'],
    undergrounds: styles['undergrounds'],
    railways: styles['railways'],
    villages: styles['villages'],
    roads: styles['roads'],
};
exports.SuggestionsGroup = function (props) {
    var name = props.name;
    return (React.createElement("div", { className: styles['group-container'] },
        React.createElement("div", null,
            React.createElement("div", { className: styles['title'] },
                React.createElement("i", tslib_1.__assign({}, utils_1.mergeStyles(TITLE_STYLES[name], styles['group-logo'])), icons_1.renderGroupIcon(name)),
                TITLES[name]),
            props.children)));
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"group-container":"geosuggest_widget-group-container-5b2b36bd3de","title":"geosuggest_widget-title-16d355ee355","group-logo":"geosuggest_widget-group-logo-8b42c112795","addresses":"geosuggest_widget-addresses-5c69f351aa6","cities":"geosuggest_widget-cities-0e786f922b1","districts":"geosuggest_widget-districts-ad6d78b931b","newbuildings":"geosuggest_widget-newbuildings-9dc385914af","undergrounds":"geosuggest_widget-undergrounds-c1ca6914de3","business":"geosuggest_widget-business-5ef30f55789","shop":"geosuggest_widget-shop-6515000e1b1","railways":"geosuggest_widget-railways-d5556dbda97","villages":"geosuggest_widget-villages-2c77bc66e54","roads":"geosuggest_widget-roads-ca87571aa94"};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
function renderGroupIcon(name) {
    //в мобильном сайте проблема с загрузкой свг, задаваемых в css фоном
    switch (name) {
        case ('cities'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "nonzero", d: "M15.2 13.6v-8H12V0H5.6v4H.8v9.6H0V16h16v-2.4h-.8zM4 13.6H2.4V12H4v1.6zm0-3.2H2.4V8.8H4v1.6zm0-3.2H2.4V5.6H4v1.6zm6.4 6.4H7.2v-2.4h3.2v2.4zm0-4.8H7.2V6.4h3.2v2.4zm0-4.8H7.2V1.6h3.2V4z" })));
        case ('districts'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "13", viewBox: "0 0 17 13" },
                React.createElement("g", { fill: "#C9C9C9", fillRule: "evenodd" },
                    React.createElement("path", { fillRule: "nonzero", d: "M13.68 3c1.592.354 2.774 1.696 2.774 3.3 0 2.545-3.61 6.3-3.61 6.3s-.82-.852-1.677-2.02c1.324-1.935 2.661-4.376 2.661-6.344 0-.426-.051-.84-.149-1.236zm-7.693 7.58A22.223 22.223 0 0 1 4.31 12.6S.7 8.845.7 6.3C.7 4.697 1.882 3.355 3.474 3c-.097.396-.148.81-.148 1.236 0 1.968 1.337 4.409 2.661 6.345z" }),
                    React.createElement("path", { d: "M8.595 0C6.055 0 4 2.003 4 4.48c0 3.36 4.595 8.32 4.595 8.32s4.595-4.96 4.595-8.32C13.19 2.003 11.135 0 8.595 0zm0 6.08c-.906 0-1.641-.717-1.641-1.6 0-.883.735-1.6 1.64-1.6.907 0 1.642.717 1.642 1.6 0 .883-.735 1.6-1.641 1.6z" }))));
        case ('newbuildings'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "12", viewBox: "0 0 17 12" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M11.485 3V.485h3V6l2.485 2.485-2.828 2.828-5.87-5.87-5.657 5.658L0 8.485 8.485 0l3 3z" })));
        case ('shoppingCenters'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "15", viewBox: "0 0 16 15" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "nonzero", d: "M14.016 13.067c0 .782-.458 1.487-1.16 1.786a1.839 1.839 0 0 1-2.046-.42 1.974 1.974 0 0 1-.406-2.107 1.878 1.878 0 0 1 1.737-1.191c1.036.001 1.875.866 1.875 1.932zM6.22 11.135a1.878 1.878 0 0 0-1.736 1.191 1.974 1.974 0 0 0 .405 2.107c.537.553 1.345.72 2.047.42a1.934 1.934 0 0 0 1.16-1.786c-.002-1.065-.84-1.93-1.876-1.932zm9.751-7.944l-.97 3.304a.506.506 0 0 1-.385.358L5.07 8.726l.093.41h8.395c.277 0 .5.23.5.514a.508.508 0 0 1-.5.515H4.763a.503.503 0 0 1-.488-.4L2.34 1.03H.5C.224 1.03 0 .8 0 .515 0 .23.224 0 .5 0h2.25c.234 0 .436.167.488.401l.47 2.126H15.5c.158 0 .307.078.4.208.095.131.123.3.078.456h-.008z" })));
        case ('businessCenters'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "15", viewBox: "0 0 15 15" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M0 12h3v-1H0V8h3V7H0V4h3V3H0V0h7v5h8v10H0v-3zm7-5v2h2V7H7zm4 0v2h2V7h-2zm-4 4v2h2v-2H7zm4 0v2h2v-2h-2z" })));
        case ('undergrounds'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "11", viewBox: "0 0 16 11" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M8 5.907L11.111 0l4 9.574H16V11h-5.556V9.574h.89l-.89-3.055L8 9.574 5.556 6.52l-.89 3.055h.89V11H0V9.574h.889l4-9.574L8 5.907z" })));
        case ('railways'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
                React.createElement("g", { fill: "none", fillRule: "nonzero" },
                    React.createElement("path", { fill: "#FFF", fillOpacity: ".01", d: "M0 0h16v16H0z" }),
                    React.createElement("path", { fill: "#757575", fillOpacity: ".54", d: "M11.429 12.571L12.57 16H11.43l-1.143-3.429H5.714L4.571 16H3.43l1.142-3.429H3.55a1.143 1.143 0 0 1-1.138-1.256l.915-9.143c.058-.584.55-1.03 1.137-1.03H6.02a2.285 2.285 0 0 1 3.96 0h1.557c.587 0 1.079.446 1.137 1.03l.915 9.143a1.143 1.143 0 0 1-1.138 1.256H11.43zM4.57 2.286v4.571h6.858V2.286H4.57zm0 6.857v1.143h1.143V9.143H4.571zm5.715 0v1.143h1.143V9.143h-1.143z" }))));
        case ('villages'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "13", viewBox: "0 0 14 13" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M9.059 13h1.647c.494 0 .823-.325.823-.813V6.5h.824c.247 0 .494-.081.659-.244.33-.325.247-.812-.083-1.137L7.165.244a.875.875 0 0 0-1.07 0L.328 5.119C0 5.444-.082 5.93.247 6.256c.082.163.33.244.577.244h.823v5.688c0 .487.33.812.824.812h1.647c.494 0 .823-.325.823-.813V9.75h3.294v2.438c0 .487.33.812.824.812z" })));
        case ('roads'):
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "14", viewBox: "0 0 15 14" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M7.758 0h1.939l.97 4.848H8.242L7.758 0zm-.97 0l-.485 4.848H3.879L4.849 0h1.939zM3.394 7.273h2.909l-.485 6.303H1.94l1.455-6.303zm7.758 0l1.454 6.303H8.727l-.485-6.303h2.91zM0 5.333h14.545v1.455h-.97v1.454h-1.454V6.788H2.424v1.454H.97V6.788H0V5.333z" })));
        case ('addresses'):
        default:
            return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "17", viewBox: "0 0 12 17" },
                React.createElement("path", { fill: "#C9C9C9", fillRule: "evenodd", d: "M5.833 0A5.83 5.83 0 0 0 0 5.833c0 4.375 5.833 10.834 5.833 10.834s5.834-6.459 5.834-10.834A5.83 5.83 0 0 0 5.833 0zm0 7.917a2.084 2.084 0 1 1 .002-4.169 2.084 2.084 0 0 1-.002 4.169z" })));
    }
}
exports.renderGroupIcon = renderGroupIcon;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Suggestion_1 = __webpack_require__(28);
exports.Suggestion = Suggestion_1.Suggestion;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var helpers_1 = __webpack_require__(29);
var SuggestionContent = function (props) {
    var item = props.item, selected = props.selected, onClick = props.onClick, onMouseOver = props.onMouseOver, inputType = props.inputType, onLinkClick = props.onLinkClick, forwardRef = props.forwardRef;
    return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles.apply(void 0, helpers_1.getSuggestionStyles(item, selected)), { onClick: onClick, onMouseOver: onMouseOver }, { 
        //удалил реактовский forwardRef из-за несовместимости версий
        ref: forwardRef }), helpers_1.getSuggestionContent(item, inputType, onLinkClick)));
};
var Suggestion = /** @class */ (function (_super) {
    tslib_1.__extends(Suggestion, _super);
    function Suggestion(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
        };
        return _this;
    }
    Suggestion.prototype.componentDidCatch = function () {
        this.setState({
            hasError: true,
        });
        // TODO: https://cianru.atlassian.net/browse/CD-50613
    };
    Suggestion.prototype.render = function () {
        if (this.state.hasError) {
            return null;
        }
        return React.createElement(SuggestionContent, tslib_1.__assign({}, this.props));
    };
    return Suggestion;
}(React.Component));
exports.Suggestion = Suggestion;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var styles = __webpack_require__(30);
var types_1 = __webpack_require__(3);
var types_2 = __webpack_require__(4);
var text_1 = __webpack_require__(31);
var utils_1 = __webpack_require__(32);
var UNDERGROUND_LINE_SHIFT = 4;
var renderUndergroundLines = function (lines, isMobile) {
    if (!lines.length) {
        return null;
    }
    return (React.createElement("div", tslib_1.__assign({}, utils_1.mergeStyles(styles['lines-container'], isMobile && styles['lines-container--mobile'])), lines.map(function (line, index) {
        var zIndex = lines.length;
        return (React.createElement("div", { key: index, className: styles['underground-line'], style: {
                backgroundColor: "#" + line.lineColor,
                left: UNDERGROUND_LINE_SHIFT * index,
                zIndex: zIndex - index
            } }));
    })));
};
function renderItemContent(item, isMobile) {
    var text;
    var matchesUnsorted;
    if (item.type === types_1.ESuggestType.geo) {
        text = item.displayName;
        matchesUnsorted = item.hl;
    }
    else {
        text = item.name;
        matchesUnsorted = item.matches;
    }
    var matches = matchesUnsorted && matchesUnsorted.sort(function (matchA, matchB) { return matchA[0] - matchB[0]; }) || [];
    var value = (text || '').trim();
    return (React.createElement("span", { className: styles['relative'] },
        item.type === types_1.ESuggestType.underground && renderUndergroundLines(item.lines, isMobile),
        !value || matches.length === 0
            ? React.createElement("span", null, text)
            : matches.map(function (match, index) {
                return (React.createElement("span", { key: index, title: text },
                    index === 0 && text.substring(0, match[0]),
                    React.createElement("strong", null, text.substring(match[0], match[1])),
                    text_1.getClosingForMatch(text, matches, index)));
            }),
        (item.type === types_1.ESuggestType.underground && item.releaseYear) &&
            React.createElement("span", null, " \u00B7 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0432 " + item.releaseYear)));
}
exports.getSuggestionStyles = function (item, selected) {
    var itemStyles = [styles['item'], selected && styles['item-selected']];
    if (types_2.isBuildingSuggest(item)) {
        itemStyles.push(styles['item-building']);
    }
    return itemStyles;
};
exports.getSuggestionContent = function (item, inputType, onLinkClick) {
    var shouldRenderLink = !(inputType === types_1.EInputType.mobile || inputType === types_1.EInputType.tablet);
    var isMobile = !(inputType === types_1.EInputType.search || inputType === types_1.EInputType.mainpage);
    var content = renderItemContent(item, isMobile);
    if (types_2.isBuildingSuggest(item)) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles['building-name'] }, content),
            React.createElement("div", { className: styles['address'] }, item.address),
            shouldRenderLink && React.createElement("a", { className: styles['link'], href: item.link, target: "_blank", onClick: onLinkClick },
                React.createElement("i", { className: styles['link-icon'] },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12" },
                        React.createElement("path", { fill: "#2B87DB", fillRule: "evenodd", d: "M12 .5V5h-1V1H7V0h5v.5zM0 1h1v10H0V1zm1 11v-1h10v1H1zM5 0v1H1V0h4zm7 11h-1V7h1v4zM10 1h1v1h-1V1zM9 2h1v1H9V2zM8 3h1v1H8V3zM7 4h1v1H7V4zM6 5h1v1H6V5z" }))))));
    }
    else {
        return content;
    }
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"geosuggest_widget-item-5d181cf9370","item-selected":"geosuggest_widget-item-selected-849216f8c34","item-building":"geosuggest_widget-item-building-46e1b21682e","building-name":"geosuggest_widget-building-name-12025751b55","address":"geosuggest_widget-address-1ab90580d79","link":"geosuggest_widget-link-1a6febe2bf7","link-icon":"geosuggest_widget-link-icon-4f85e1162c9","lines-container":"geosuggest_widget-lines-container-7c76e765950","lines-container--mobile":"geosuggest_widget-lines-container--mobile-d6901aae21c","underground-line":"geosuggest_widget-underground-line-8ad0a65ba6a","relative":"geosuggest_widget-relative-f45d832d7ce"};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Получает часть строки после совпадения
 * @param {string} text -  текст в котором выделяются совпадения.
 * @param {TMatches} matches - массив совпадений.
 * @param {number} index - индекс совпадения.
 */
function getClosingForMatch(text, matches, index) {
    return index === matches.length - 1
        ? text.substring(matches[index][1])
        : text.substring(matches[index][1], matches[index + 1][0]);
}
exports.getClosingForMatch = getClosingForMatch;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(3), exports);
tslib_1.__exportStar(__webpack_require__(4), exports);
tslib_1.__exportStar(__webpack_require__(5), exports);
tslib_1.__exportStar(__webpack_require__(6), exports);
tslib_1.__exportStar(__webpack_require__(7), exports);
tslib_1.__exportStar(__webpack_require__(8), exports);
tslib_1.__exportStar(__webpack_require__(9), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
tslib_1.__exportStar(__webpack_require__(11), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultCookieOptions = {
    domain: '.cian.ru',
    path: '/',
    secure: true,
};
exports.setCookie = function (name, value, config) {
    var options = Object.assign({}, defaultCookieOptions, config);
    var expires = options.expires;
    var cookieExpires;
    if (expires) {
        if (typeof expires === 'number') {
            var d = new Date();
            cookieExpires = new Date(d.setTime(d.getTime() + expires * 1000)).toUTCString();
        }
        else if (expires instanceof Date) {
            cookieExpires = expires.toUTCString();
        }
    }
    document.cookie =
        // tslint:disable-next-line:prefer-template
        name + "=" + encodeURIComponent(value) + "; " +
            ("path=" + options.path) +
            ("; domain=" + options.domain) +
            (cookieExpires ? "; expires=" + cookieExpires : '') +
            (options.secure ? "; secure" : '');
};
exports.deleteCookie = function (name, config) {
    exports.setCookie(name, '', Object.assign({}, config, {
        expires: -1,
    }));
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var hostPatterns = [
    ['beta', /stage\.cian\.ru$/i],
    ['development', /dev[2,3]?\.cian\.ru$/i],
    ['local', /local(\.map)?\.cian\.ru$/i],
    ['local', /^localhost(:\d+)?$/i],
    ['production', /cian\.ru$/i],
];
function calculateEnvironmentByHost(host) {
    for (var _i = 0, hostPatterns_1 = hostPatterns; _i < hostPatterns_1.length; _i++) {
        var hostPattern = hostPatterns_1[_i];
        if (hostPattern[1].test(host)) {
            return hostPattern[0];
        }
    }
    return 'unknown';
}
exports.calculateEnvironmentByHost = calculateEnvironmentByHost;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCookies = function (cookiesString) {
    var cookiesObject = {};
    var pairs = cookiesString.split(/; */);
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eqIdx = pair.indexOf('=');
        // skip things that don't look like key=value
        if (eqIdx < 0) {
            continue;
        }
        var key = pair.substr(0, eqIdx).trim();
        // tslint:disable-next-line:restrict-plus-operands
        var value = pair.substr(eqIdx + 1, pair.length).trim();
        // quoted values
        if (value[0] === '"') {
            value = value.slice(1, -1);
        }
        // only assign once
        if (!(key in cookiesObject)) {
            cookiesObject[key] = decodeURIComponent(value);
        }
    }
    return cookiesObject;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var monthNames = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];
function isValidDate(date) {
    return !isNaN(date.getTime());
}
exports.isValidDate = isValidDate;
function leftPadZero(value) {
    if (value < 10) {
        return "0" + value;
    }
    return value.toString();
}
exports.leftPadZero = leftPadZero;
function getTime(date) {
    return leftPadZero(date.getHours()) + ":" + leftPadZero(date.getMinutes());
}
exports.getTime = getTime;
function mapDayToString(date, now) {
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (now.getFullYear() !== date.getFullYear() || now.getMonth() !== date.getMonth()) {
        return undefined;
    }
    if (now.getDate() === date.getDate()) {
        return 'сегодня';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'вчера';
    }
    now.setDate(now.getDate() - 1);
    if (now.getDate() === date.getDate()) {
        return 'позавчера';
    }
    return undefined;
}
exports.mapDayToString = mapDayToString;
function getFormattedDate(date, now) {
    var day = mapDayToString(date);
    if (!now || !isValidDate(now)) {
        now = new Date();
    }
    else {
        now = new Date(now.getTime());
    }
    if (day) {
        return day + " " + getTime(date);
    }
    if (now.getFullYear() === date.getFullYear()) {
        return date.getDate() + " " + monthNames[date.getMonth()] + " " + getTime(date);
    }
    return date.getDate() + " " + monthNames[date.getMonth()] + " " + date.getFullYear();
}
exports.getFormattedDate = getFormattedDate;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var devices = [
    {
        regex: /iPhone/i,
        type: 'phone',
    }, {
        regex: /iPod/i,
        type: 'phone',
    }, {
        regex: /iPad/i,
        type: 'tablet',
    }, {
        regex: /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /Android/i,
        type: 'tablet',
    }, {
        regex: /Windows Phone/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
        type: 'tablet',
    }, {
        regex: /(BlackBerry|BB10)/i,
        type: 'phone',
    }, {
        regex: /Opera Mini/i,
        type: 'phone',
    }, {
        regex: /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        type: 'phone',
    }, {
        regex: /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
        type: 'phone',
    },
];
exports.identifyDeviceType = function (userAgent) {
    if (userAgent) {
        for (var i = 0; i < devices.length; i++) {
            var device = devices[i];
            if (device.regex.test(userAgent)) {
                return device.type;
            }
        }
    }
    return 'desktop';
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function normalizeHost(host) {
    var rules = [
        [/^([^\.]+)\.micro\.cian\.tech$/, undefined],
        [/^(?:[^\.]+\.)?beta\d*\.stage\.cian\.ru$/, 'python'],
        [/^[^\.]+\.([^\.]+)\.stage\.cian\.ru$/, undefined],
        [/^(?:[^\.]+\.)?[^\.]+\.dev\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?beta\d*\.cian\.ru$/, 'python'],
        [/^(?:[^\.]+\.)?cian\.ru$/, 'python'],
    ];
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var _a = rules_1[_i], pattern = _a[0], name_1 = _a[1];
        var matches = pattern.exec(host);
        if (matches) {
            if (name_1) {
                return name_1;
            }
            else {
                return matches[1];
            }
        }
    }
    return host;
}
exports.normalizeHost = normalizeHost;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NOT_NUMBER_REX = /[^0-9]/g;
var NUMBER_GROUP_REX = /.{1,3}/g;
function parseNumber(s) {
    var sign = s[0] === '-' ? '-' : '';
    var _a = s.split('.'), integer = _a[0], fractional = _a[1];
    return {
        fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
        integer: integer.replace(NOT_NUMBER_REX, ''),
        sign: sign,
    };
}
exports.parseNumber = parseNumber;
function numberToPrettyString(defaultNumber, separator) {
    if (separator === void 0) { separator = ','; }
    var _a = parseNumber(String(defaultNumber)), fractional = _a.fractional, integer = _a.integer, sign = _a.sign;
    var parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
    var prettyInteger = parsedInteger.reverse().map(reverseString).join(' ');
    return !fractional ? "" + sign + prettyInteger : "" + sign + prettyInteger + separator + fractional;
}
exports.numberToPrettyString = numberToPrettyString;
function reverseString(s) {
    return s.split('').reverse().join('');
}
exports.keepValueInRange = function (value, min, max) {
    var val = Math.max(value, min); // min < val
    val = Math.min(val, max); // val < max
    return val;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function plural(n, variants) {
    if (n % 10 === 1 && n % 100 !== 11) {
        return variants[0];
    }
    if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
        return variants[1];
    }
    return variants[2];
}
exports.plural = plural;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    if (params.center) {
        params.containerElement.scrollTop =
            targetElementOffsetTop
                - containerElementClientHeight / 2
                + targetElementScrollHeight / 2;
    }
    else {
        var containerBottom = containerElementScrollTop + containerElementClientHeight;
        var valueBottom = targetElementOffsetTop + targetElementScrollHeight;
        if (valueBottom > containerBottom) {
            params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
        }
        else if (targetElementOffsetTop < containerElementScrollTop) {
            params.containerElement.scrollTop = targetElementOffsetTop;
        }
    }
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    billionPostfix: 'млрд.',
    fractionalLength: 2,
    millionPostfix: 'млн.',
    separator: undefined,
    thousandPostfix: 'тыс.',
};
function shortenNumber(i, userOptions) {
    var options = userOptions
        ? Object.assign({}, defaultOptions, userOptions)
        : defaultOptions;
    var getFractional = fractional(options.fractionalLength);
    var applyPostfix = withPostfix(options.separator);
    if (i >= 1000000000) {
        var value = getFractional(i, 1000000000);
        return applyPostfix(value, options.billionPostfix);
    }
    else if (i >= 1000000) {
        var value = getFractional(i, 1000000);
        return applyPostfix(String(value), options.millionPostfix);
    }
    else if (i >= 1000) {
        var value = getFractional(i, 1000);
        return applyPostfix(value, options.thousandPostfix);
    }
    else {
        var value = getFractional(i);
        return applySeparator(Number(value), options.separator);
    }
}
exports.shortenNumber = shortenNumber;
function withPostfix(separator) {
    return function (value, postfix) {
        return applySeparator(Number(value), separator) + " " + postfix;
    };
}
function fractional(fractionalLength) {
    return function (value, divider) {
        if (!divider) {
            return value.toFixed(fractionalLength);
        }
        var num = value / divider;
        var numAsArray = String(num).split('.');
        var originalFractionChapter = numAsArray[1];
        if (originalFractionChapter &&
            originalFractionChapter.length > 2 &&
            Number(originalFractionChapter.slice(-1)) < 5) {
            return num.toFixed(fractionalLength);
        }
        else if (originalFractionChapter) {
            var newFractionChapter = originalFractionChapter.length > fractionalLength
                ? originalFractionChapter.slice(0, fractionalLength)
                : originalFractionChapter;
            return numAsArray[0] + "." + newFractionChapter;
        }
        return String(num);
    };
}
function applySeparator(value, separator) {
    if (typeof separator === 'string') {
        return value.toString().replace('.', separator);
    }
    return value.toString();
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function isStyleProps(styleArgument) {
    if (!!styleArgument && typeof styleArgument === 'object' && !Array.isArray(styleArgument)) {
        return styleArgument.hasOwnProperty('style') && styleArgument.hasOwnProperty('className');
    }
    return false;
}
function mergeClassNames(target, cls) {
    if (!cls || !cls.length) {
        return target;
    }
    return target.length === 0
        ? cls
        : target + " " + cls;
}
function mergeStyleProperties(target, style) {
    return tslib_1.__assign({}, target, style);
}
function mergerStyleConfigs(target, style) {
    return {
        className: mergeClassNames(target.className, style.className),
        style: mergeStyleProperties(target.style, style.style),
    };
}
// tslint:disable-next-line:no-any
function isStyleConifg(target) {
    if (!target) {
        return false;
    }
    return typeof target === 'object' || typeof target === 'string';
}
function reducer(acc, style) {
    if (!isStyleConifg(style)) {
        return acc;
    }
    if (Array.isArray(style)) {
        return style.reduce(reducer, acc);
    }
    if (typeof style === 'object') {
        return isStyleProps(style)
            ? mergerStyleConfigs(acc, style)
            : mergerStyleConfigs(acc, { className: '', style: style });
    }
    acc.className = mergeClassNames(acc.className, style);
    return acc;
}
function mergeStyles() {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return styles.reduce(reducer, { style: {}, className: '' });
}
exports.mergeStyles = mergeStyles;


/***/ })
/******/ ]);
//# sourceMappingURL=frontend-utils.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Message_1 = __webpack_require__(34);
exports.Message = Message_1.Message;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var styles = __webpack_require__(35);
var TITLE_DEFAULT = 'Не удалось получить возможные варианты';
var TEXT_DEFAULT = 'Попробуйте ещё раз';
exports.Message = function (props) {
    var _a = props.title, title = _a === void 0 ? TITLE_DEFAULT : _a, _b = props.text, text = _b === void 0 ? TEXT_DEFAULT : _b;
    return (React.createElement("div", { className: styles['message_geo'] },
        React.createElement("div", { className: styles['message_text'] },
            React.createElement("div", { className: styles['message_text--title'] },
                React.createElement("strong", null, title)),
            React.createElement("div", { className: styles['message_text--light'] }, text))));
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"message_geo":"geosuggest_widget-message_geo-453777ae292","message_text":"geosuggest_widget-message_text-031820e5163","message_text--title":"geosuggest_widget-message_text--title-0228b49b549","message_text--light":"geosuggest_widget-message_text--light-6832c00bdd1"};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TITLE_HEIGHT = 18;
/**
 * Прокручивает попап к выбранному варианту так, чтобы последний был поностью видим
 * @param {Object} params парметры для вычисления скролла
 * @param {HTMLElement} params.containerElement - контейнер всех вариантов.
 * @param {HTMLElement} params.targetElement - выбранный вариант.
 * @param {HTMLElement} params.parentElement - родитель выбранного варианта.
 * @param {center} boolean - признак необходимостии центрирования.
 */
exports.scrollTo = function (params) {
    var containerElementClientHeight = params.containerElement.clientHeight;
    var containerElementScrollTop = params.containerElement.scrollTop;
    var parentElementOffsetTop = params.parentElement.offsetTop;
    var parentElementScrollHeight = params.parentElement.scrollHeight;
    var targetElementOffsetTop = params.targetElement.offsetTop;
    var targetElementScrollHeight = params.targetElement.scrollHeight;
    var containerBottom = containerElementScrollTop + containerElementClientHeight;
    var valueBottom = targetElementOffsetTop
        + targetElementScrollHeight
        + parentElementOffsetTop
        + (parentElementScrollHeight);
    if (valueBottom > containerBottom) {
        params.containerElement.scrollTop = valueBottom - containerElementClientHeight;
    }
    else if (targetElementOffsetTop + parentElementOffsetTop < containerElementScrollTop) {
        params.containerElement.scrollTop = targetElementOffsetTop + parentElementOffsetTop - TITLE_HEIGHT;
    }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Chevron_1 = __webpack_require__(38);
exports.Chevron = Chevron_1.Chevron;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var utils_1 = __webpack_require__(2);
var icon_1 = __webpack_require__(39);
var style = __webpack_require__(40);
exports.Chevron = function (props) {
    var isOpen = props.isOpen, onClick = props.onClick;
    return (React.createElement(icon_1.ChevronIcon, tslib_1.__assign({}, utils_1.mergeStyles(style['chevron'], isOpen && style['chevron--opened']), { onClick: onClick })));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(1);
var React = __webpack_require__(0);
function ChevronIcon(props) {
    return (React.createElement("svg", tslib_1.__assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 6" }, props),
        React.createElement("path", { fill: "#C3C3C3", d: "M4.3 5.7L.1 1.6C-.2 1.2-.1.6.2.3c.3-.4.9-.4 1.3-.2L5 3.4 8.4.1c.4-.3 1-.2 1.3.2.3.4.4.9.1 1.3L5.6 5.7c-.2.2-.4.3-.6.3-.2 0-.5-.1-.7-.3z" })));
}
exports.ChevronIcon = ChevronIcon;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"chevron":"geosuggest_widget-chevron-f6b6c1c1041","chevron--opened":"geosuggest_widget-chevron--opened-93792f997f6"};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"geo-suggest":"geosuggest_widget-geo-suggest-c1bb7d12cec","input-wrapper":"geosuggest_widget-input-wrapper-902906734ae","preloader-mobile":"geosuggest_widget-preloader-mobile-a8745edd438","preloader-mainpage":"geosuggest_widget-preloader-mainpage-8bc0e34bd7a","disabled":"geosuggest_widget-disabled-c171f5572bf"};

/***/ })
/******/ ]);
//# sourceMappingURL=geosuggest-widget.js.map